import { AppState } from "../app.state";

export const getRegistrationStatus = (state: AppState) => state.registration.loadStatus;
